import React from 'react';
import { DataGridCell } from '../components';

class DataColumn extends React.Component {
    renderLabel(label) {
        if (label) {
            return (
                <span className="cell-label">{label}</span>
            )
        } else {
            return null;
        }
    }

    render () {
        let Cell = this.props.cellComponent || DataGridCell;
        let metaData = {
            displayName: this.props.displayName,
            columnName: this.props.columnName
        }
        let data = (typeof this.props.filter === 'function') ? this.props.filter(this.props.data, this.props.rowData, metaData) : this.props.data;

        let header = this.renderLabel(metaData.displayName);
        const noLabelClass = !header ? 'no-label' : '';

        return (
            <div className={[this.props.className, 'component-data-column'].join(' ')}>
                { header }
                <div className={['cell-data', noLabelClass].join(' ')}>
                    <Cell {...this.props.cellComponentProps} metadata={metaData} data={data} rowData={this.props.rowData} />
                </div>
            </div>
        );
    }
}

export default DataColumn;



// WEBPACK FOOTER //
// ./web-app/components/data-column.jsx